import { useAuth } from "./useAuth";
import { can, type AdminPermission } from "./rbac";

/** True when the signed-in admin's role grants `permission`. */
export function usePermission(permission: AdminPermission): boolean {
  const { admin } = useAuth();
  return can(admin?.role, permission);
}
